<div class='container'>
    <mat-card>
        <mat-card-title>ERROR ALERT SETTING</mat-card-title>
        <br />
        <mat-form-field class='subid' appearance="outline">
            <mat-label>SUB ID</mat-label>
            <input matInput placeholder="SUB ID">
            <button mat-icon-button matSuffix>
                <mat-icon>done</mat-icon>
            </button>
        </mat-form-field>
        <br />

        <form>
            <div class='row'>
                <div class='col-md-3 col-6'>
                    <label class="form-check-label" for='very_low'>Sensor Fault</label>
                    <input class="form-check-input" type="checkbox" value="" id="very_low" />
                    <br /><br />
                </div>

                <div class='col-md-3 col-6'>
                    <label class="form-check-label" for='low'>No Signal</label>
                    <input class="form-check-input" type="checkbox" value="" id="low" />
                    <br /><br />
                </div>

                <div class='col-md-3 col-6'>
                    <label class="form-check-label" for='high'>Com Error</label>
                    <input class="form-check-input" type="checkbox" value="" id="high" />
                    <br /><br />
                </div>

                <div class='col-md-3 col-6'>
                    <label class="form-check-label" for='very_high'>Calib Error</label>
                    <input class="form-check-input" type="checkbox" value="" id="very_high" />
                    <br /><br />
                </div>

                <div class='col-md-3 col-6'>
                    <label class="form-check-label" for='sms'>RF Error</label>
                    <input class="form-check-input" type="checkbox" value="" id="sms" />
                    <br /><br />
                </div>

                <div class='col-md-3 col-6'>
                    <label class="form-check-label" for='call'>Timer Error</label>
                    <input class="form-check-input" type="checkbox" value="" id="call" />
                    <br /><br />
                </div>

                <div class='col-md-3 col-6'>
                    <label class="form-check-label" for='call'>EEPROM Error</label>
                    <input class="form-check-input" type="checkbox" value="" id="call" />
                    <br /><br />
                </div>

            </div>
            <br />
            <div class='submit'>
                <mat-form-field appearance="outline">
                    <mat-label>Phone Number</mat-label>
                    <input matInput placeholder="Phone Number">
                </mat-form-field>
                <br />
                <button mat-raised-button>Submit</button>
            </div>
        </form>
    </mat-card>
</div>